import React from 'react';
import MoneyContainer from './styles';
import { Typography } from '@material-ui/core';

const Money = ({ value, lastValue, description, promotion }) => (
	<MoneyContainer>
		{lastValue ? <div className="line" /> : ''}
		<Typography className="money__last-value">{lastValue}</Typography>
		<Typography className="money__promotion">{promotion}</Typography>
		<Typography className={`money__value ${lastValue ? 'money__value__big' : ''}`}>
			{value}
		</Typography>
		<Typography className="money__description">{description}</Typography>
	</MoneyContainer>
);

export default Money;
